<template>
  <div>
    <b-dropdown
      lazy
      id="dropdown-1"
      variant="link"
      right
      role="navigation"
      class="m-md-2"
      v-if="$auth.hasPermission(config.permissions.order_write)"
    >
      <template #button-content>
        <i class="bx bx-dots-vertical-rounded"></i>
      </template>
      <b-dropdown-item  @click.stop="handleActionClick" @click="viewDetails(order.base_id)">{{
        trans.get("__JSON__.View")
      }}</b-dropdown-item>
      <b-dropdown-item
        v-if="order.status_name == statuses.placed && order.delivery_type == 0"
         @click.stop="handleActionClick"
        @click="changeStatus(order.base_id, 'confirmed', order)"
        >{{ trans.get("__JSON__.Confirm Order") }}</b-dropdown-item
      >
      <b-dropdown-item
        v-if="order.status_name == statuses.placed"
         @click.stop="handleActionClick"
        @click="changeStatus(order.base_id, statuses.readytocollect, order)"
        >{{ trans.get("__JSON__.Ready To Collect") }}</b-dropdown-item
      >
      <b-dropdown-item
        v-if="this.order.driver.length > 0 &&
          order.status_name == statuses.readytocollect &&
          order.delivery_type == 1
        "
         @click.stop="handleActionClick"
        @click="assignDriverPopup"
        >{{ trans.get("__JSON__.Assign Driver") }}</b-dropdown-item
      >
      <!-- <b-dropdown-item v-if="order.status_name == statuses.inkitchen" @click="changeStatus(order.base_id,statuses.readytoserve)">{{trans.get('__JSON__.Ready To Delivery Order')}}</b-dropdown-item> -->
      <b-dropdown-divider
        v-if="
          [
            statuses.placed,
            statuses.inkitchen,
            statuses.readytocollect,
            statuses.ontheway,
            statuses.scheduled,
          ].includes(order.status_name)
        "
      ></b-dropdown-divider>

      <b-dropdown-item
        v-if="
          [statuses.readytocollect, statuses.ontheway].includes(
            order.status_name
          ) && order.delivery_type == 0
        "
         @click.stop="handleActionClick"
        @click="changeStatus(order.base_id, statuses.delivered, order)"
        >{{ trans.get("__JSON__.Deliver Order") }}</b-dropdown-item
      >

      <b-dropdown-item
        v-if="
          [statuses.readytoserve].includes(
            order.status_name
          )
        "
         @click.stop="handleActionClick"
        @click="deliveredOrderPopup(order.base_id, statuses.delivered)"
        >{{ trans.get("__JSON__.Deliver Order") }}</b-dropdown-item
      >

      <b-dropdown-item
        v-if="
          [
            statuses.placed,
            statuses.readytocollect,
            statuses.ontheway,
          ].includes(order.status_name)
        "
         @click.stop="handleActionClick"
        @click="cancelOrderPopup(order.base_id, statuses.cancelled)"
        ><span class="text-danger">{{
          trans.get("__JSON__.Cancel Order")
        }}</span></b-dropdown-item
      >
      <b-dropdown-item v-if="[statuses.placed].includes(order.status_name)">
        <span>
          <router-link
            :to="{ name: 'edit-order', params: { order_id: order.base_id } }"
            >{{ trans.get("__JSON__.Update Order") }}
          </router-link>
        </span>
      </b-dropdown-item>
      <!-- <b-dropdown-item v-if="[statuses.delivered].includes(order.status_name)" @click="createInvoice(order.base_id,statuses.delivered)" ><span class="text-danger">{{trans.get('__JSON__.Create Invoice')}}</span></b-dropdown-item> -->
    </b-dropdown>

    <i
      v-else
      v-b-tooltip="'Need Permission'"
      class="mdi mdi-information h4 text-danger"
    ></i>
    <OrderShow
      v-if="showModal"
      :order-id="order.base_id"
      :orderStatus="orderStatus"
      @hidden="showModal = false"
    />
    <b-modal
      id="modal-sm"
      size="lg"
      title-class="font-18"
      @hidden="resetModal"
      @ok="cancelOrder"
      :ok-disabled="loading"
      :ok-title="
        loading
          ? trans.get('__JSON__.Cancelling')
          : trans.get('__JSON__.Cancel Order')
      "
      ok-only
      ok-variant="danger"
      ref="cancel-modal"
      lazy
    >
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-between w-100">
          <h4 class="mb-0">{{ trans.get("__JSON__.Cancel Order") }}</h4>
          <h4 class="mb-0">{{ order.order_id }}</h4>
        </div>
        <button type="button" aria-label="Close" class="close" @click="close()">
          &times;
        </button>
      </template>

      <div class="row">
        <div class="col-12">
          <b-form role="form">
            <div class="row">
              <div
                class="col"
                v-for="(reason, index) in cancel_reasons"
                :key="index"
              >
                <!-- <a href="#" @click="onReasonSelect(reason)">
                            <b-card header-class="bg-transparent border-primary" class="border border-primary"
                                :bg-variant="other_selected && reason == 'Other' || reason == cancelled_desc ? 'primary' : 'default'"
                                 body-class="d-flex align-items-center justify-content-center height-100">
                                <h5 class="card-title mt-0" :class="{'text-white': (other_selected && reason == 'Other' || reason == cancelled_desc)}">{{reason}}</h5>
                            </b-card>
                            </a> -->
              </div>
            </div>
            <b-form-group label="Cancel Description">
              <b-form-textarea
                id="textarea"
                v-model="cancelled_desc"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
                minlength="6"
              ></b-form-textarea>
            </b-form-group>
            <!-- <b-form-group v-if="!$auth.partner_login">
                         <b-form-checkbox
                            id="checkbox-1"
                            switch
                            v-model="is_refundable"
                            class="text-right"
                            name="checkbox-1"
                            size="lg"
                            value="1"
                            unchecked-value="0"
                        >
                        Is Refundable
                        </b-form-checkbox>
                    </b-form-group> -->
          </b-form>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-sm"
      size="lg"
      title-class="font-18"
      @hidden="resetModal"
      @ok="deliveredOrder"
      :ok-disabled="loading"
      :ok-title="
        loading
          ? trans.get('__JSON__.Delivering')
          : trans.get('__JSON__.Deliver Order')
      "
      ok-only
      ok-variant="danger"
      ref="delivered-modal"
      lazy
    >
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-between w-100">
          <h4 class="mb-0">{{ trans.get("__JSON__.Deliver Order") }}</h4>
          <h4 class="mb-0">{{ order.order_id }}</h4>
        </div>
        <button type="button" aria-label="Close" class="close" @click="close()">
          &times;
        </button>
      </template>

      <div class="row">
        <div class="col-12">
          <b-form role="form">
            <b-form-group label="Notes">
              <b-form-textarea
                id="textarea"
                v-model="delivered_note"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-form>
        </div>
      </div>
    </b-modal>
    <OrderAssign
      ref="orderAssign"
      :order="order"
      :show-button="false"
      @actionChanged="$emit('actionChanged')"
      v-if="
        order.status_name == statuses.readytocollect &&
        order.delivery_type == 1
      "
    />
  </div>
</template>

<script>
import OrderShow from "./order-show";
import OrderAssign from "./order-assign";
import { debounce, order_statuses } from "./../../../Helper/helper";
import config from "../../../config";
import { orderService } from "../../../services";
//import moment from "moment-timezone";

export default {
  props: ["order","orderStatus"],
  components: { OrderShow, OrderAssign },
  data() {
    return {
      config: config,
      showModal: false,
      statuses: order_statuses,
      cancelled_desc: "",
      delivered_note: "",
      is_refundable: false,
      showPopup: false,
      order_id: null,
      cancel_reasons: [
        "Too Busy",
        "Out of Delivery Area",
        "Out of Stock",
        "Other",
      ],
      other_selected: false,
      loading: false,
      // cancelThisOrder:debounce((bvModalEvt)=>{
      //     bvModalEvt.preventDefault()
      //     this.cancelOrder(bvModalEvt)
      // })
    };
  },
  methods: {
    viewDetails(id) {
      this.showModal = true;
      this.orderLoading = true;
      this.orderId = id;
    },
    handleActionClick(event) {
      event.stopPropagation(); // Prevent event from bubbling up
      this.$emit('action-click'); // Optional: Emit an event if needed
    },
    assignDriverPopup() {
      if (this.order.driver.length > 0 && this.$refs.orderAssign) {
      console.log("checkDrivers called", this.$refs.orderAssign);
        this.$refs.orderAssign.checkDrivers();
      }
    },
    changeStatus(id, status, order) {
      // if (
      //   (status == "ReadyToCollect" && order.delivery_type == 1) &&
      //   moment(order.delivery_date_time)
      //     .subtract(15, "minutes")
      //     .format("YYYY-MM-DD HH:mm:ss") <=
      //     moment()
      //       .clone()
      //       .tz(this.$auth.setting.timezone)
      //       .format("YYYY-MM-DD HH:mm:ss")
      // ) {
      //   this.$toasted.error(
      //     "You can move ready to collect before 15 minutes to start time"
      //   );
      //   return false;
      // }

      const data = {
        order_id: atob(id),
        status_name: status,
        vendor_id: this.$auth.getVendorId(),
        is_langauge: this.$auth.setting.primary_lang,
      };
      orderService.changeOrderStatus(data).then((response) => {
        if (response.data.code == 200) {
          this.$toasted.success(response.data.message);
        } else {
          this.$toasted.error(response.data.message);
        }
        // this.$emit('showLoader',false);
        this.$emit("actionChanged");
      });
    },
    createInvoice(id, status) {
      const data = {
        order_id: atob(id),
        status_name: status,
        vendor_id: this.$auth.getVendorId(),
        is_langauge: this.$auth.setting.primary_lang,
      };
      orderService.createInvoice(data).then((response) => {
        if (response.data.code == 200) {
          this.$toasted.success(response.data.msg);
        } else {
          this.$toasted.error(response.data.msg);
        }
        this.$emit("actionChanged");
      });
    },
    ownerOrderStatus(id, status) {
      const data = {
        order_id: atob(id),
        status_name: status,
        vendor_id: this.$auth.getVendorId(),
      };
      orderService.ownerOrderStatus(data).then((response) => {
        if (response.data.code == 200) {
          this.$toasted.success(response.data.msg);
        } else {
          this.$toasted.error(response.data.msg);
        }
        this.$emit("actionChanged");
      });
    },
    resetModal() {
      this.order_id = null;
      this.is_refundable = false;
    },
    cancelOrderPopup(id, status) {
      this.$refs["cancel-modal"].show();
      this.order_id = id;
    },
    cancelOrder(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.loading = true;
      if (this.cancelled_desc == "") {
        this.$toasted.info("Please select cancel reason.");
        this.loading = false;
        return false;
      }

      const data = {
        orderId: atob(this.order_id),
        cancelled_desc: this.cancelled_desc,
        is_refundable: this.is_refundable,
      };
      orderService.cancelOrder(data).then((response) => {
        if (response.data.code == 200) {
          this.$toasted.success(response.data.message);
        } else {
          this.$toasted.error(response.data.message);
        }
        this.loading = false;
        this.$refs["cancel-modal"].hide();
        this.$emit("actionChanged");
      });
    },
    deliveredOrderPopup(id, status) {
      this.$refs["delivered-modal"].show();
      this.order_id = id;
    },
    deliveredOrder(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.loading = true;
      if (this.delivered_note == "") {
        this.$toasted.info("Please write deliver note.");
        this.loading = false;
        return false;
      }
      const data = {
        orderId: atob(this.order_id),
        delivered_note: this.delivered_note,
      };
      orderService.deliverOrder(data).then((response) => {
        if (response.data.code == 200) {
          this.$toasted.success(response.data.message);
        } else {
          this.$toasted.error(response.data.message);
        }
        this.loading = false;
        this.$refs["delivered-modal"].hide();
        this.$emit("actionChanged");
      });
    },
    onReasonSelect(reason) {
      if (reason !== "Other") {
        this.cancelled_desc = reason;
        this.other_selected = false;
      } else {
        this.other_selected = true;
        this.cancelled_desc = "";
      }
    },
  },
};
</script>
<style  scoped>
.height-100 {
  height: 100px;
}
</style>
